/**
 * Consent document versions constants
 */

export const i18nKeys = {
  TITLE: 'systemSettings.consentDocumentVersions.title',
  EXPLANATION: {
    TITLE: 'systemSettings.consentDocumentVersions.explanation.title',
    BODY: 'systemSettings.consentDocumentVersions.explanation.body',
    MATERIAL: 'systemSettings.consentDocumentVersions.explanation.material',
    TYPO: 'systemSettings.consentDocumentVersions.explanation.typo',
    SCHEDULING: 'systemSettings.consentDocumentVersions.explanation.scheduling'
  },
  TABLE: {
    TITLE: 'systemSettings.consentDocumentVersions.table.title',
    DOCUMENT: 'systemSettings.consentDocumentVersions.table.document',
    VERSION: 'systemSettings.consentDocumentVersions.table.version',
    EFFECTIVE_AT: 'systemSettings.consentDocumentVersions.table.effectiveAt',
    RE_ACCEPTANCE: 'systemSettings.consentDocumentVersions.table.reAcceptance',
    EMPTY: 'systemSettings.consentDocumentVersions.table.empty',
    YES: 'systemSettings.consentDocumentVersions.table.yes',
    NO: 'systemSettings.consentDocumentVersions.table.no',
    ACTIONS: 'systemSettings.consentDocumentVersions.table.actions',
    WITHDRAW: 'systemSettings.consentDocumentVersions.table.withdraw'
  },
  FORM: {
    TITLE: 'systemSettings.consentDocumentVersions.form.title',
    DOCUMENT_LABEL: 'systemSettings.consentDocumentVersions.form.documentLabel',
    VERSION_LABEL: 'systemSettings.consentDocumentVersions.form.versionLabel',
    VERSION_PLACEHOLDER:
      'systemSettings.consentDocumentVersions.form.versionPlaceholder',
    EFFECTIVE_AT_LABEL:
      'systemSettings.consentDocumentVersions.form.effectiveAtLabel',
    RE_ACCEPTANCE_LABEL:
      'systemSettings.consentDocumentVersions.form.reAcceptanceLabel',
    RE_ACCEPTANCE_HELP:
      'systemSettings.consentDocumentVersions.form.reAcceptanceHelp',
    PUBLISH_BUTTON: 'systemSettings.consentDocumentVersions.form.publishButton',
    VALIDATION_REQUIRED:
      'systemSettings.consentDocumentVersions.form.validationRequired'
  },
  SUCCESS: 'systemSettings.consentDocumentVersions.success',
  WITHDRAWN: 'systemSettings.consentDocumentVersions.withdrawn',
  ERRORS: {
    LOAD_FAILED: 'systemSettings.consentDocumentVersions.errors.loadFailed',
    PUBLISH_FAILED:
      'systemSettings.consentDocumentVersions.errors.publishFailed',
    WITHDRAW_FAILED:
      'systemSettings.consentDocumentVersions.errors.withdrawFailed'
  }
};
